import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { PROPOSAL_STATUS, projectProposalsApi, type ProjectProposalListItem } from '../../api/projectProposals'
import { Button, Callout, DataTable, EmptyState, LoadingState, Page, PageHeader, StatusPill } from '../../components/ui'

const when = (iso: string) => new Date(iso).toLocaleDateString('it-IT', { day: 'numeric', month: 'short', year: 'numeric' })

/** Le pagine progetto per i clienti (progetti.equalstudio.it): l'IA le scrive dai dati, qui si rivedono e si pubblicano. */
export function ProjectProposalsPage() {
  const navigate = useNavigate()
  const [items, setItems] = useState<ProjectProposalListItem[] | null>(null)
  const [error, setError] = useState('')

  useEffect(() => {
    let alive = true
    projectProposalsApi.list()
      .then(r => { if (alive) setItems(r) })
      .catch(e => { if (alive) setError(e instanceof Error ? e.message : 'Errore nel caricamento.') })
    return () => { alive = false }
  }, [])

  return (
    <Page>
      <PageHeader
        title="Pagine progetto"
        icon="auto_awesome"
        {...(items ? { count: items.length } : {})}
        actions={<Button variant="filled" icon="add" onClick={() => navigate('/project-proposals/new')}>Nuova pagina</Button>}
      />
      {error ? <Callout tone="error">{error}</Callout>
        : items === null ? <LoadingState />
        : items.length === 0 ? (
          <EmptyState icon="auto_awesome" title="Nessuna pagina progetto."
            description="Inserisci i dati del cliente: l’IA scrive la pagina, tu la rivedi e la pubblichi con una password." />
        ) : (
          <DataTable>
            <thead><tr><th>Cliente</th><th>Indirizzo</th><th>Stato</th><th>Versione</th><th>Pubblicata</th><th>Aggiornata</th></tr></thead>
            <tbody>
              {items.map(p => (
                <tr key={p.id}>
                  <td><Link to={`/project-proposals/${p.id}`}>{p.clientName}</Link></td>
                  <td className="text-nowrap">/{p.slug}</td>
                  <td><StatusPill tone={PROPOSAL_STATUS[p.status].tone}>{PROPOSAL_STATUS[p.status].label}</StatusPill></td>
                  <td>{p.currentVersion || '—'}</td>
                  <td className="text-nowrap">
                    {p.publishedVersion == null ? '—'
                      : `v${p.publishedVersion}${p.publishedVersion !== p.currentVersion ? ' (ci sono modifiche)' : ''}`}
                  </td>
                  <td className="text-nowrap">{when(p.updatedAt)}</td>
                </tr>
              ))}
            </tbody>
          </DataTable>
        )}
    </Page>
  )
}
